module.exports = __webpack_public_path__ + "assets/img/icon_forex-4.3520f69f.svg";